import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PnL from "@/pages/PnL";
import PnLCompany from "@/pages/PnLCompany";
import Clients from "@/pages/Clients";
import Upcoming from "@/pages/Upcoming";
import Dictionaries from "@/pages/Dictionaries";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Загрузка…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/pnl" element={<Protected><PnL /></Protected>} />
          <Route path="/pnl/:companyId" element={<Protected><PnLCompany /></Protected>} />
          <Route path="/clients" element={<Protected><Clients /></Protected>} />
          <Route path="/upcoming" element={<Protected><Upcoming /></Protected>} />
          <Route path="/dictionaries" element={<Protected><Dictionaries /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
